import styled from 'styled-components'
import { HEIGHT_FOOTER_PAGE } from '../constants/sizes'

export const ContentFooter = styled.div`
    min-height: ${HEIGHT_FOOTER_PAGE + 'px'};
`
